export default "__VITE_ASSET__DULr3F9H__"